export const DD_MM = 'DD.MM';
export const DD_MM_YYYY = 'DD.MM.YYYY';
